import store from '@/store'
import axios from 'axios'

export default {


  async getVouchers () {
    try {
      let result = await axios.get(store.getters.getPromotionsApi + '/voucher')
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao obter vouchers'}
    }
  },

  async saveVoucher (voucher) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.post(store.getters.getPromotionsApi + '/voucher',
      voucher, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log('error', error.e)
      let errorMsg = error.e.msg
      if (!errorMsg) {
        errorMsg = 'Erro ao salvar voucher'
      }
      return { error: true, code: 500, msg: errorMsg}
    }
  },

  async removeVoucher(id) {
    try {
      let result = await axios.delete(store.getters.getPromotionsApi + '/voucher/' + id)
      return result.data
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, code: 500, msg:'Erro ao excluir voucher'}
    }
  }

}
